<template>
    <div class="chatList">
        <div class="scroll-box">
            <vue-scroll :ops="ops" @handle-scroll="handleScroll" v-if="userList.length>0">
                <div class="chat-item" v-for="(item,index) in userList" :key="index" :class="{active:curId == item.id}"
                    @click="selectUser(item)">
                    <div class="avatar">
                        <img :src="item.show_avatar" alt="">
                        <div class="status" :class="{off:item.online == 0}"></div>
                    </div>
                    <div class="user-info">
                        <div class="hd">
                            <span class="name line1">
                                <el-badge :value="item.no_read>0?item.no_read:''" class="items">
                                    <div :title="item.show_nickname" class="itemnick">{{item.show_nickname}}</div>
                                </el-badge>
                            </span>
                            <template>
                                <span
                                    class="label wechat">{{item.user_type_id_text?item.user_type_id_text:'公众号'}}</span>
                            </template>
                        </div>
                        <div class="bd line1">
                            <template v-if="item.msg_type ==1">{{item.content}}</template>
                            <template v-if="item.msg_type ==3">[图片]</template>
                            <template v-if="item.message_type ==5">[商品]</template>
                            <template v-if="item.message_type ==6">[订单]</template>
                        </div>
                    </div>
                    <div class="right-box">
                        <div class="time">{{item.show_time}}</div>
                        <!-- <div class="num">
                            <a href="#" class="demo-badge"></a>
                        </div> -->
                    </div>
                </div>
            </vue-scroll>
        </div>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'
    import {
        HappyScroll
    } from 'vue-happy-scroll'
    export default {
        name: "chatList",
        props: {
            userOnline: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            newRecored: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            searchData: {
                type: String,
                default: ''
            }
        },
        components: {
            HappyScroll,
            // empty
        },
        watch: {
            userOnline: {
                handler(nVal, oVal) {
                    if (nVal.hasOwnProperty('to_uid')) {
                        this.userList.forEach((el, index) => {
                            if (el.to_uid == nVal.to_uid) {
                                el.online = nVal.online
                                if (nVal.online == 1) {
                                    this.$Notice.info({
                                        title: '上线通知',
                                        desc: `${el.nickname}上线`
                                    });
                                }

                            }
                        })
                    }
                },
                deep: true
            },
            searchData: {
                handler(nVal, oVal) {
                    if (nVal != oVal) {
                        this.nickname = nVal
                        this.page = 1
                        this.isScroll = true
                        this.userList = []
                        this.isSearch = true
                        this.getList()
                    }
                },
                deep: true
            },
            userList: {
                handler(nVal, oVal) {
                    let user_id = sessionStorage.getItem('user_chat_id')
                    if (user_id) {
                        let user = nVal.find(a => a.id == user_id)
                        this.selectUser(user)
                        sessionStorage.removeItem('user_chat_id')
                    }

                },
                deep: true
            }
        },
        data() {
            return {
                doc_id: '',
                // 
                page: 1,
                limit: 15,
                isScroll: true,
                // 
                userList: [],
                curId: '',
                isSearch: false,
                ops: {
                    vuescroll: {
                        mode: 'native',
                        enable: false,
                        tips: {
                            deactive: 'Push to Load',
                            active: 'Release to Load',
                            start: 'Loading...',
                            beforeDeactive: 'Load Successfully!'
                        },
                        auto: false,
                        autoLoadDistance: 0,
                        pullRefresh: {
                            enable: false
                        },
                        pushLoad: {
                            enable: true,
                            auto: true,
                            autoLoadDistance: 10
                        }
                    },
                    bar: {
                        background: '#393232',
                        opacity: '.5',
                        size: '5px'
                    }
                },
                searchValue: '',
            }
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {

            let vue = this
            vue.bus.$on('getdoc', data => {
                this.doc_id = data
                this.userList = []
                this.getList()
                this.curId = ''
            })
            vue.bus.$on('change', data => {
                this.searchValue = data
                this.getList()
            })
        },
        methods: {
            getList() {
                let vue = this
                let obj = {
                    data: {
                        form_type: 'admin',
                        search: this.searchValue,
                        page: this.page,
                        page_count: this.limit,
                        user_id: this.user.id
                    },
                    type: "userChatList"
                }
                vue.$openws.ws.send(obj);
                // if (!this.isScroll) return
                /*axios.post('/admin/pc/KfChat/chatRecordList', {
                    page: this.page,
                    page_count: this.limit,
                    user_id: this.doc_id,
                    search: this.searchValue,
                }, {
                    token: true
                }).then(res => {
                    this.userList = res.data.data
                })*/
            },
            toChat(item) {
                let vue = this
                let obj = {
                    data: {
                        source: 4,
                        user_id: this.user.id,
                        to_id: item.user_id
                    },
                    type: "to_chat"
                }
                vue.$openws.ws.send(obj);
            },

            // 选择用户
            selectUser(item) {
                let vue = this
                vue.$parent.page = 1
                this.curId = item.id
                vue.$emit('setDataId', item)
                this.toChat(item)
            },
            clearbindnum(id) {
                this.userList.forEach(element => {
                    if (id == element.id) {
                        element.num = ''
                    }
                });
            },
            handleScroll(vertical, horizontal, nativeEvent) {
                if (vertical.process == 1) {
                    // this.getList()
                }
            },
            getdoc(doc_id) {
                this.doc_id = doc_id
                this.getList()
            }
        },
        destroyed() {
            this.bus.$off()
        }
    }
</script>

<style lang="scss" scoped>
    .chatList {
        display: flex;
        flex-direction: column;
        width: 325px;
        height: 742px;
        border-right: 1px solid #ECECEC;

        .scroll-box {
            flex: 1;
            height: 500px;
            overflow: hidden;

            .chat-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 12px 10px;
                height: 74px;
                box-sizing: border-box;
                border-left: 3px solid transparent;
                cursor: pointer;

                &.active {
                    background: #EFF0F1;
                    border-left: 3px solid #1890FF;
                }
            }
        }
    }




    .avatar {
        position: relative;
        width: 40px;
        height: 40px;

        img {
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }

        .status {
            position: absolute;
            right: 3px;
            bottom: 0;
            width: 8px;
            height: 8px;
            background: #48D452;
            border: 1px solid #fff;
            border-radius: 50%;

            &.off {
                background: #999999;
            }
        }

    }

    .user-info {
        width: 180px;
        margin-left: 12px;
        margin-top: 5px;
        font-size: 16px;

        .hd {
            display: flex;
            align-items: center;
            color: rgba(0, 0, 0, 0.65);
            width: 100%;

            .name {
                width: 61%;

            }

            .items {
                width: 100%;
            }

            .itemnick {
                font-size: 12px;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .label {
                margin-left: 5px;
                color: #3875EA;
                font-size: 12px;
                background: #D8E5FF;
                border-radius: 2px;
                padding: 1px 5px;

                &.H5 {
                    background: #FAF1D0;
                    color: #DC9A04;
                }

                &.wechat {
                    background: rgba(64, 194, 73, 0.16);
                    color: #40C249;
                }

                &.pc {
                    background: rgba(100, 64, 194, 0.16);
                    ;
                    color: #6440C2;
                }
            }
        }

        .bd {
            margin-top: 3px;
            font-size: 12px;
            color: #8E959E;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .right-box {
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        color: #8E959E;

        .time {
            font-size: 12px;
        }

        .num {
            margin-right: 12px;
        }

    }


    .chart-scroll {
        margin-top: -10px;
    }
</style>